
class StickyForm extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button[type="submit"]');
      console.log(this.button);
      //this.button.addEventListener('click', this.onButtonClick.bind(this));
  
    }
  
    connectedCallback() {
      // this.productFormButton = document.querySelector('.product-form form[action*="/cart/add"]');
      this.productFormButton = document.querySelector('.shopify-section.product-section .small__description') || document.querySelector('.product-form form[action*="/cart/add"]');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
  
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.form = document.querySelector('.product-form');
      
  
  
      this.createObserver();
    }
  
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.productFormButton);
    }
  
    // isInViewport(elem) {
    //   var bounding = elem.getBoundingClientRect();
    //   return (
    //       bounding.top >= 0 &&
    //       bounding.left >= 0 &&
    //       bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //       bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    //   );
    // }
  
    // onScroll() {
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   if (!this.preventReveal) {
  
    //     if (this.isInViewport(this.productFormButton)) {
    //       requestAnimationFrame(this.hideForm.bind(this));
    //     } else {
    //       requestAnimationFrame(this.revealForm.bind(this));
    //     }
    //     if (this.isInViewport(document.querySelector('footer .footer__content-bottom'))) {
    //       requestAnimationFrame(this.hideForm.bind(this));
    //     }
        
    //   } else {
    //     window.clearTimeout(this.isScrolling);
  
    //       this.isScrolling = setTimeout(() => {
    //         this.preventReveal = false;
    //       }, 66);
  
    //   }
    //   return false;
  
    //   if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    //     requestAnimationFrame(this.hide.bind(this));
    //   } else if (scrollTop < this.currentScrollTop && scrollTop + window.innerHeight > this.headerBounds.bottom ) {
    //     if (!this.preventReveal) {
    //       requestAnimationFrame(this.reveal.bind(this));
    //     } else {
    //       window.clearTimeout(this.isScrolling);
  
    //       this.isScrolling = setTimeout(() => {
    //         this.preventReveal = false;
    //       }, 66);
  
    //       requestAnimationFrame(this.hide.bind(this));
    //     }
    //   } else if (scrollTop <= this.headerBounds.top) {
    //     requestAnimationFrame(this.reset.bind(this));
    //   }
  
  
    //   this.currentScrollTop = scrollTop;
    // }

    isInViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    isAboveViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return rect.bottom <= 0;
    }

    onScroll() {
  if (this.preventReveal) {
    window.clearTimeout(this.isScrolling);
    this.isScrolling = setTimeout(() => {
      this.preventReveal = false;
    }, 66);
    return;
  }

  const formBtn = this.productFormButton;
  const footer = document.querySelector('footer .footer__content-bottom');

  // 1. Hide when form button is visible
  if (this.isInViewport(formBtn)) {
    requestAnimationFrame(this.hideForm.bind(this));
    return;
  }

  // 2. Hide when footer is visible
  if (footer && this.isInViewport(footer)) {
    requestAnimationFrame(this.hideForm.bind(this));
    return;
  }

  // 3. Reveal ONLY if user has scrolled past the form
  if (this.isAboveViewport(formBtn)) {
    requestAnimationFrame(this.revealForm.bind(this));
  } else {
    // Form is still below viewport → do NOT reveal
    requestAnimationFrame(this.hideForm.bind(this));
  }
}

  
    hideForm() {
      this.classList.add('sticky-form-hidden');
      this.classList.remove('sticky-form-sticky');
  
    }
  
    revealForm() {
      this.classList.add('sticky-form-sticky', 'animate');
      this.classList.remove('sticky-form-hidden');
    }
  
    reset() {
      this.classList.remove('sticky-form-hidden', 'sticky-form-sticky', 'animate');
    }
  
  }
  
  customElements.define('sticky-form', StickyForm);